<div class="camera-container" >

    <video #videoPlayer></video>

    <div class="vh-center op-25 face-outline" style="z-index: 100">
        <img style="height: auto; margin-top: 10px" src="assets/faceOutline.png" alt="" srcset="">
    </div>

    <div *ngIf="loading" class="flex-bottom justify-center z-200" style="background-color: #f5f5f5;">

        <div class="auto-margin-x" style="margin-top: 20px">
            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#00b6ff" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="feather feather-camera">
                <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"></path>
                <circle cx="12" cy="13" r="4"></circle>
            </svg>
        </div>

        <div class="vh-center op-50 fs-10">
            Accessing camera...
        </div>

    </div>

    <div *ngIf="cameraError" class="flex-bottom justify-center z-300" style="background-color: #f5f5f5; margin-top: 55px;">

        <div class="auto-margin-x">


            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#e74c3c" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="feather feather-camera-off">
                <line x1="1" y1="1" x2="23" y2="23"></line>
                <path
                    d="M21 21H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3m3-3h6l2 3h4a2 2 0 0 1 2 2v9.34m-7.72-2.06a4 4 0 1 1-5.56-5.56">
                </path>
            </svg>

            <!-- <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none"
                stroke="#e74c3c" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"
                class="feather feather-camera">
                <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"></path>
                <circle cx="12" cy="13" r="4"></circle>
            </svg> -->

        </div>

        <div class="vh-center op-50 fw-black fs-10">
            Camera Access Denied!
        </div>

        <div class="txt-center pd-left-25 pd-right-25 mg-top-15 op-50 fs-10">
            Please allow us to access your camera from browser settings and then try again.
        </div>

    </div>

    <div class="flex-bottom z-400" style="width: 75%; margin: 0 auto;">

        <div [ngStyle]="{'height': adjustImageHeight ? imageHeight.toString()+'px' : 'auto' }" [style.borderWidth]="imageHeight != 240 && imageHeight != 0 ? '2px' : '0px'" style="overflow: hidden; border-bottom: 2px solid #fff;">
            <img #outputImage style="object-fit: cover; width: 100%; height: 250px">
        </div>

        <div *ngIf="imageHeight != 240 && imageHeight != 0" style="flex: 1; background-color: #ffffff50;"></div>

    </div>

</div>